import React from "react";

import { BettingOfferStatus } from "@api-types/offer/offer-history/BettingOfferStatus";
import { TipButtonProps } from "@data-types/offer/event-row/TipButtonProps";
import EventHistoryStatusIcon from "@features/offer/shared/event/offer-history/EventHistoryStatusIcon";
import { getOfferHistoryStatusClass } from "@features/offer/shared/event/offer-history/utils";

import { OfferHistoryPlayerTipButton } from "./OfferHistory/OfferHistoryPlayerTipButton";

import cn from "classnames";

export function OfferHistoryTipButton(props: TipButtonProps) {
	if (props.tip?.status === undefined) {
		return null;
	}
	if (props.isPlayer) {
		return <OfferHistoryPlayerTipButton tip={props.tip} />;
	}

	const status = props.tip.status;

	return (
		<button
			className={cn("offer--additional__item quote", getOfferHistoryStatusClass(status))}
			disabled={status === BettingOfferStatus.Lose}
		>
			<div className="quota__tip" title={props.tip?.displayTip}>
				{props.tip?.displayTip}
			</div>

			<div className="quota__odd">
				<EventHistoryStatusIcon status={status} />
			</div>
		</button>
	);
}
